
































































import { Component, Vue } from "vue-property-decorator";
import Search from "@/components/Search.vue";
import TicketList from "@/components/sale/list/TicketList.vue";
import { IStatusListRequest } from "@/types/status";
import { Action, Getter } from "vuex-class";
import { ISalesListRequest } from "@/types/sales";
import { ISelectItem } from "@/types";
import { IUser } from "@/types/user";

@Component({
  components: { TicketList, Search },
})
export default class extends Vue {
  @Action("status/getList")
  public getStatuses!: (params: IStatusListRequest) => Promise<void>;

  @Getter("status/selectItem")
  public statuses!: ISelectItem[];

  @Action("sales/adminGetList")
  public getSales!: (params: ISalesListRequest) => Promise<void>;

  @Getter("sales/selectItem")
  public salers!: ISelectItem[];

  @Getter("auth/me")
  public auth!: IUser;

  public query = "";
  public status = "inprogress";
  public charge_id = 0;
  public member_id = 0;

  public dialog = false;

  public async mounted() {
    this.member_id = Number(this.$route.params.member_id);

    await Promise.all([
      this.getStatuses({ per_page: 0 }),
      this.getSales({ per_page: 0 }),
    ]);
  }

  public async search(): Promise<void> {
    const target = this.$refs.ticketlist as TicketList;
    await target.getList();
  }

  public get statusOptions() {
    this.statuses.push({
      text: "処理済み以外",
      value: "inprogress",
    });

    return this.statuses;
  }

  public get chargeOptions() {
    this.salers.unshift({ text: "すべて", value: "0" });
    return this.salers;
  }
}
